import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-action-needed-infobox',
  imports: [InfoboxComponent, TranslatePipe, ButtonComponent],
  templateUrl: './action-needed-infobox.component.html',
})
export class ActionNeededInfoboxComponent {
  private readonly router = inject(Router);

  protected count = input(1);
  protected jobsToUpdateCount = input(0);

  protected goToJobsToUpdateView(): void {
    this.router.navigate(['offers/views/jobs:prosemirror'], { replaceUrl: true });
  }
}
